<ng-container [formGroup]="model">
    @switch (field.input.type) {
        @case (inputType.ONLY_TEXT) {
            <input
                [id]="field.name"
                [formControlName]="field.name"
                [style]="'background-color: transparent; border: 0; box-shadow: none; padding-left: 0;' + (field.input.style ?? '')"
                class="form-control-plaintext"
                type="text"
                placeholder="-"
                readonly />
        }

        @case (inputType.NUMERIC) {
            <input
                *ngIf="isEditable; else readOnly"
                [id]="field.name"
                [formControlName]="field.name"
                [attr.aria-describedby]="describedById || null"
                placeholder="..."
                pInputText
                type="number" 
                [attr.aria-invalid]="isInvalid" />
        }

        @case (inputType.TEXT) {
            <input
                *ngIf="isEditable; else readOnly"
                [id]="field.name"
                [formControlName]="field.name"
                [attr.aria-describedby]="describedById || null"
                placeholder="..."
                pInputText
                [pKeyFilter]="keyFilterFor()"
                type="text"
                [maxlength]="maxLengthFor()"
                [attr.autocapitalize]="isSpanishIdField() ? 'characters' : null"
                [attr.inputmode]="isSpanishIdField() ? 'text' : null"
                [attr.spellcheck]="isSpanishIdField() ? 'false' : null"
                (input)="handleTextInput($event)"
                (blur)="handleTextBlur()"
                [attr.aria-invalid]="isInvalid" />
        }

        @case (inputType.PASSWORD) {
            <div *ngIf="isEditable; else readOnly" class="reactive-password-field">
                <input
                    [id]="field.name"
                    [formControlName]="field.name"
                    [attr.aria-describedby]="describedById || null"
                    pInputText
                    [type]="passwordInputTypeFor()"
                    [attr.aria-invalid]="isInvalid" />

                <button
                    type="button"
                    class="reactive-password-toggle"
                    [attr.aria-label]="passwordToggleLabelFor()"
                    [attr.aria-pressed]="isPasswordVisible()"
                    (click)="togglePasswordVisibility()">
                    <i [class]="passwordIconFor()" aria-hidden="true"></i>
                </button>
            </div>
        }

        @case (inputType.TEXT_MASK) {
            <p-inputMask
                *ngIf="isEditable; else readOnly"
                [inputId]="field.name"
                [formControlName]="field.name"
                [attr.aria-describedby]="describedById || null"
                [mask]="field.input.textMaskConfiguration?.mask"
                [placeholder]="field.input.textMaskConfiguration?.mask"
                [attr.aria-invalid]="isInvalid">
            </p-inputMask>
        }

        @case (inputType.TWO_FIELDS_CONCAT) {
            <div *ngIf="isEditable && hasTwoFieldConcat(); else readOnly" class="mt-0 d-flex justify-content-between">
                <input
                    [formControlName]="field.input.twoFieldsConcatConfiguration?.subField1 ?? ''"
                    [attr.aria-describedby]="describedById || null"
                    placeholder="..."
                    pInputText
                    type="number" 
                [attr.aria-invalid]="isInvalid" />
                <span class="mx-3">{{ field.input.twoFieldsConcatConfiguration?.separator || 'x' }}</span>
                <input
                    [formControlName]="field.input.twoFieldsConcatConfiguration?.subField2 ?? ''"
                    [attr.aria-describedby]="describedById || null"
                    placeholder="..."
                    pInputText
                    type="number" 
                [attr.aria-invalid]="isInvalid" />
            </div>
        }
    }
</ng-container>

<ng-template #readOnly>
    <app-reactive-read-only-field [field]="field" [model]="model"></app-reactive-read-only-field>
</ng-template>
